import {
  Dialog,
  DialogContent,
  Paper,
  Slide,
  styled,
  SxProps,
  Breakpoint,
  Box
} from '@mui/material'
import React, { PropsWithChildren } from 'react'
import { TransitionProps } from '@mui/material/transitions'
import { colors } from '../../constants/colors'
import { SquareButton } from '../../elements/basic-elements'
import CloseIcon from '../../images/icons/close-icon'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>
  },
  ref: React.Ref<unknown>
) {
  return (
    <Slide direction="up" ref={ref} {...props} timeout={500} easing="cubic-bezier(0, 0, 0, 1)" />
  )
})

const CenteredModal: React.FC<
  PropsWithChildren & {
    open: boolean
    onClose: () => void
    showClose?: boolean
    positionAtBottomOnMobile?: boolean
    backdropChildren?: React.ReactNode
    disableContainer?: boolean
    sx?: SxProps
    maxWidth?: false | Breakpoint
    noPadding?: boolean
  }
> = ({
  children,
  backdropChildren,
  disableContainer,
  open,
  onClose,
  showClose,
  positionAtBottomOnMobile,
  sx,
  noPadding,
  maxWidth = 'sm'
}) => {
  return (
    <StyledDialog
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={onClose}
      closeAfterTransition
      TransitionComponent={Transition}
      PaperComponent={disableContainer ? Box : StyledPaper}
      PaperProps={{ sx: { margin: 2, ...sx } }}
      positionAtBottomOnMobile={positionAtBottomOnMobile}
      disableContainer={disableContainer}
      maxWidth={maxWidth}
      slotProps={{
        backdrop: { children: backdropChildren }
      }}
    >
      {showClose && (
        <Box sx={{ alignSelf: 'flex-end', margin: '20px' }}>
          <SquareButton variant="contained" color="tertiary" disableElevation onClick={onClose}>
            <CloseIcon />
          </SquareButton>
        </Box>
      )}
      <DialogContent
        sx={{
          ...(noPadding && { padding: 0 })
        }}
      >
        {children}
      </DialogContent>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)<{
  positionAtBottomOnMobile: boolean
  disableContainer: boolean
}>`
  ${({ theme, positionAtBottomOnMobile, disableContainer }) => `
    ${
      disableContainer &&
      `
        & .MuiDialogContent-root {
          padding: 0px!important;
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        & .MuiPaper-root {
          flex: 1;
          max-height: 100%;
          overflow: scroll;
        }
      `
    }
    ${theme.breakpoints.down('md')} {
      & .MuiDialog-container {
        align-items: ${positionAtBottomOnMobile ? 'flex-end' : 'center'};
      }
    }
  `}
`

const StyledPaper = styled(Paper)`
  ${({ theme }) => `
    background-image: none;
    background-color: ${theme.palette.mode == 'dark' ? colors.DARK_MODE_80 : colors.GEORGIAN_BAY_70};
    color: ${colors.WHITE};
    max-width: 100%;
  `}
`

export default CenteredModal
